import React, {useState} from 'react';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {handleLogout, handleSubmitLogin} from "../../services/auth-service";
import {useDispatch} from "react-redux";
import {actionLogged} from "../../redux/actions/LoginActions";
import logo from "@images/MULTICOTIZADOR LOGO.svg";
import { useEffect } from 'react';

export default function Login() {

    const dispatch = useDispatch();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const visiblePassword = () => {
        setPasswordVisible(!passwordVisible);
    };

    const LoginSchema = Yup.object().shape({
        user: Yup.string()
            .min(3, 'El usuario debe contener al menos 3 caracteres.')
            .max(30, 'No se permiten usuarios de mas de 30 caracteres.')
            .required('Es necesario ingresar el usuario.'), password: Yup.string()
            .min(3, 'La contraseña debe contener al menos 3 caracteres.')
            .max(30, 'La contraseña es demasiado larga.')
            .required('Se requiere la contraseña para poder acceder.')
    });

    useEffect(() => {
        //handleLogout()
    },[])

    return (
        <div className="login-background vh-100">
            <Formik
                initialValues={{
                    user: '',
                    password: '',
                    ejecutivo: ''
                }}
                onSubmit={(values, {resetForm}) => {
                    return handleSubmitLogin(values.user, values.password, values.ejecutivo, false) && dispatch(actionLogged);
                }}
                validationSchema={LoginSchema}>

                {({errors, touched, values}) => (
                    <div className="container d-flex vh-100">
                        <div className="row justify-content-center align-self-center">
                            <div className="col px-3 my-auto">

                                <div className="px-5 my-auto">
                                    <img className="img-fluid logo-img pb-4" src={logo} alt="Logo"/>
                                </div>

                                <h1 className="align-middle text-light slogan px-5">Cotiza, compara y contrata el mejor
                                    seguro de
                                    auto en minutos.</h1>
                            </div>
                            <div className="col px-5">
                                <div className="card login-card justify-content-center px-5">
                                    <Form>
                                        <div>
                                            <h4 className="mt-4 mb-4 sesion">Iniciar Sesión </h4>
                                        </div>

                                        <div className="form-group">
                                            <ErrorMessage name="user" component={() => (
                                                <div
                                                    className="text-danger">{errors.user || touched.password} </div>)}/>
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <span
                                                        className="input-group-text p-3 bg-transparent border-end-0 border-2"><i
                                                        className="bi bi-person-fill text-secondary"></i></span>
                                                </div>
                                                <Field name="user" type="text"
                                                       className="form-control border-2 p-3 border-start-0"
                                                       placeholder="Nombre de usuario"/>
                                            </div>
                                        </div>

                                        <div className="form-group mt-1">
                                            <ErrorMessage name="password" component={() => (
                                                <div
                                                    className="text-danger">{errors.password || touched.password}</div>)}/>
                                            <div className="input-group mb-1">
                                                <div className="input-group-prepend">
                                            <span className="input-group-text p-3 bg-transparent border-end-0 border-2">
                                                <i className="bi bi-lock-fill text-secondary"></i>
                                            </span>
                                                </div>
                                                <Field name="password" type={passwordVisible ? "text" : "password"}
                                                       className="form-control p-3 border-2 border-start-0 border-end-0"
                                                       placeholder="Contraseña"/>
                                                <span data-toggle="tooltip"
                                                      title="Ver o esconder contraseña"
                                                      className="input-group-text bg-transparent border-start-0 border-2"
                                                      role="button"
                                                      onClick={visiblePassword}>
                                                <i className="bi bi-eye-fill text-secondary"></i>
                                            </span>
                                            </div>
                                            <div className="form-group mt-2">
                                                <Field as="select" name="ejecutivo"
                                                       className="form-control form-select p-3 rounded border-2 text-secondary"
                                                       required>
                                                    <option value="" selected disabled>Seleccionar tipo de cuenta...
                                                    </option>
                                                    <option value="1">Ejecutivo</option>
                                                    <option value="2">Otro</option>
                                                </Field>
                                            </div>
                                            {/*
                                            <div className="form-group mt-4 mx-2">
                                                <label className="container-checkbox">
                                                    Soy Ejecutivo
                                                    <Field type="checkbox" name="ejecutivo"/>
                                                    <span className="checkmark-box"></span>
                                                </label>
                                            </div>
                                            */}
                                        </div>


                                        <div className="float-end mt-3">
                                            <button type="submit" className="btn btn-acceso">Entrar</button>
                                        </div>
                                    </Form>
                                </div>
                                {/*
                                <div className="text-light mx-4 mt-2">En caso de requerir apoyo entra aquí.</div>
                                */}
                            </div>
                        </div>
                    </div>
                )}
            </Formik>

        </div>

    )
}